import { render } from "./loadcircle.vue?vue&type=template&id=e3eec9d0"
const script = {}
script.render = render

export default script